export const testWordsData = [{ id: 1, korean: "도착", english: "arrival" }];
